import React from 'react';

import InterestsLoader from './InterestsLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import Divider from '../../Shared/UI/Divider/components/Divider';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import PageSectionTitle from '../../Shared/UI/PageSectionTitle/components/PageSectionTitle';
import NewUnrecognizedInterestForm from './NewUnrecognizedInterestForm';
import InterestsTable from './InterestsTable';
import InterestsPageController from './InterestsPageController';

import styles from './Interests.module.scss';

const Interests = ({ authenticatedUser }) => {
  return (
    <>
      <InterestsLoader authenticatedUser={authenticatedUser} />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text={'Interests'} />
          <NewUnrecognizedInterestForm />
          <Divider />
          <PageSectionTitle text={'Interests'} />
          <InterestsTable />
          <InterestsPageController />
        </Stack>
      </div>
    </>
  );
};

export default Interests;
